export default {
  props:{
    hasDashBorder: { type: Boolean, default: false },
    hasOrangeBlock: { type: Boolean, default: false },
    hasStar: { type: Boolean, default: false },
    hideNSC: { type: Boolean, default: false },
    invertArrow: { type: Boolean, default: false },
    isBMWMoto: { type: Boolean, default: false },
    isLostLead: { type: Boolean, default: false },
    isHeader: { type: Boolean, default: false },
    isSmaller: { type: Boolean, default: false },
    kpi: { type: Object, default: undefined },
    kpiPrewave: { type: Object, default: undefined },
    monochrome: { type: Boolean, default: false },
    nsckpi:  { type: Object, default: undefined },
    overallByWave: { type: Object, default: undefined },
    showInlineYtd: { type: Boolean, default: false },
    isDark: { type: Boolean, default: false },
    showNpsBar: { type: Boolean, default: false },
    showPrewaves: { type: Boolean, default: true },
    titleText: { type: String, default: '' },
    useTitleOverKpiName: { type: Boolean, default: false }
  },

  methods: {
    isLongText: function (text) {
      if (text === null) {
        return false;
      }
      return text.length > 24
    },
    getSizeClasses: function() {
      let result = '';

      if (this.isDark && this.hasDashBorder) {
        result = result + ' ti_border_dark_dashed';
      } else if (this.isDark && !this.hasDashBorder) {
        result = result + ' ti_border_dark';
      } else if (!this.isDark && this.hasDashBorder) {
        result = result + ' ti_dashedborder';
      } else {
        result = result + ' ti_border';
      }

      if  (!this.isHeader) {
        result = result + ' ti_space';
      }

      return result;
    }
  },

  computed: {
    // creates a unified Kpi from "kpi" and "kpiPrewave". "kpi" is always needed.
    // If "kpiPrewave" is not set, "kpi" is returned as it was by default.
    // Else survey waves of "kpiPrewave" will be mapped to "kpi"
    getEffectiveKpi: function() {
      // no kpi, return 'undefined' kpi, if kpi and no prewave, just return kpi
      if (!this.kpi || (this.kpi && !this.kpiPrewave)) {
        return this.kpi;
      }

      // create a clone of kpi
      var clone = JSON.parse(JSON.stringify(this.kpi));
      // set sort order of waves to unsorted (untagged)
      clone.tagged = false;

      // keep actual waves
      var waves = clone.SurveyWave;

      // get all prewaves
      clone.SurveyWave = !this.kpiPrewave.SurveyWave ? [] : JSON.parse(JSON.stringify(this.kpiPrewave.SurveyWave));

      // remove all prewaves that are also included in actual waves
      clone.SurveyWave = _.remove(clone.SurveyWave, function(n) {
        return _.find(waves, ['Name', n.Name]) == undefined;
      });

      // add waves from actual wave
      _.forEach(waves, function(wave) {
        clone.SurveyWave.push(wave);
      });

      return clone;
    },
    getTooltipText: function() {
      if (!this.kpi || !this.kpi.QuestionText)
        return ''
      return this.kpi.QuestionText
    },
    isNarrow: function () {
      if (!this.kpi || !this.kpi.KpiName) { return false }
      return this.kpi.KpiName.length > 22 && this.kpi.KpiName.length <= 30
    },
    isVeryNarrow: function () {
      if (!this.kpi || !this.kpi.KpiName) { return false }
      return this.kpi.KpiName.length > 30
    },
    getKpiName: function() {
      if (!this.kpi || (!this.kpi.KpiName && !this.useTitleOverKpiName)) {
         return this.$t('Webportal.Dashboard.NotAvailable');
      }

      // locking is needed to prevent text from adhoc changing and flickering when user changes brands selection
      if (this.useTitleOverKpiName === true) {
        if (this.lockedText === undefined) {
          this.lockedText = this.titleText;
        }
        return this.lockedText;
      }

      if (this.kpi && this.kpi.KpiNameShort) {
        return this.showNpsBar ? this.kpi.KpiNameShort + '*' : this.kpi.KpiNameShort;
      }

      return this.showNpsBar ? this.kpi.KpiName + '*' : this.kpi.KpiName;
    },
    getIsAvailable: function() {
      if (!this.kpi) {
        return false
      }
      if (!this.kpi.KpiName && !this.showNpsBar) {
        return false;
      }
      return true
    },
    hasNsc: function() {
      if (!this.kpi || !this.kpi.SurveyWave || _.size(this.kpi.SurveyWave) === 0) {
        return false
      }
      var result =  this.kpi.SurveyWave[0].ResultNSC
      return result  != undefined
    }
  }
};
